import * as React from 'react';
import { fontFamilyMedium, fontFamilyRegular } from 'style/fonts';
import styled from 'styled-components';
import { useZstdHeader } from '../useZstdHeader';
import svcs from 'services';
import { LANG_EN, LANG_EN_US, LANG_KO_KR } from 'language/langutil';
import { i18ntrans } from 'language/i18nkey';
import { BRKS } from 'util/variables';

type Props = {
  height?: string;
  main: boolean;
};
export const CountrySelect = (props: Props) => {
  const setLanguage = (lang: string) => {
    svcs.svcLang.setLanguage(lang);
    localStorage.setItem('ssq-language', lang);
    window.location.href = '/';
  };
  const trans = i18ntrans.header;
  return (
    <UserPopup className="country-select" style={{ height: props.height }} $main={props.main}>
      <div>
        <button
          onClick={(e) => {
            setLanguage(LANG_KO_KR);
            useZstdHeader.setState({ countrySelect: false });
          }}
        >
          <span className="bold">{trans('I18N_FILTER_KOREA')}</span>
          <span className="light">{trans('I18N_FILTER_KOREAN')}</span>
        </button>
      </div>
      <div>
        <button
          onClick={() => {
            setLanguage(LANG_EN);
            useZstdHeader.setState({ countrySelect: false });
          }}
        >
          <span className="bold">{trans('I18N_FILTER_GLOBAL')}</span>
          <span className="light">English</span>
        </button>
      </div>
      <div>
        <button
          onClick={() => {
            setLanguage(LANG_EN_US);
            useZstdHeader.setState({ countrySelect: false });
          }}
        >
          <span className="bold">{trans('I18N_FILTER_USA')}</span>
          <span className="light">English</span>
        </button>
      </div>
    </UserPopup>
  );
};

const UserPopup = styled.div<{ $main?: boolean }>`
  background: white;
  font-size: 1.5rem;
  width: 24rem;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 102;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  color: #2a2c2f;

  &.country-select {
    width: auto;
    min-width: 14.5rem;
    padding: 1.5rem 1rem;
    right: ${(p) => (p.$main ? '12rem' : '3rem')};
    @media screen and (max-width: ${BRKS.tabletMax}) {
      right: ${(p) => (p.$main ? '4rem' : '4rem')};
    }

    button {
      height: 3.8rem;
      line-height: 3.8rem;
      display: block;
      padding: 0 1.6rem;
      //border-bottom: 0.1rem solid #c8d6ea;
      text-align: center;

      border-radius: 0.4rem;
      &:hover {
        background-color: #e5e5e5;
      }

      span.bold {
        ${fontFamilyMedium};
        font-size: 1.6rem;
        color: #2a2c2f;
        padding-right: 0.6rem;
      }

      span.light {
        ${fontFamilyRegular};
        font-size: 1.4rem;
        color: #7783a1;
      }
    }

    button:last-child {
      border-bottom: none;
    }
  }
  /* 
  @media screen and (min-width: 765px) {
    animation-duration: 0.5s;
    animation-name: popupbottom;
    @keyframes popupbottom {
      from {
        transform: translateY(-100%);
      }

      to {
        transform: translateY(0);
      }
    }
  }
  @media screen and (max-width: 1199px) {
    animation: MenuOpen 0.5s;

    @keyframes MenuOpen {
      from {
        transform: translateX(100%);
      }

      to {
        transform: translateX(0);
      }
    }
  } */

  > div {
    //border-bottom: solid 1px #c7d6ea;

    &:active {
      background: rgba(64, 126, 219, 0.3);
    }

    &:last-child {
      border-bottom: none;
    }

    > button {
      width: 100%;
      font-size: 1.2rem;
      text-align: left;
      color: #2a2c2f;
      ${fontFamilyMedium};

      a {
        display: block;
        width: 100%;
        color: #2a2c2f;
        padding: 1.6rem;
      }

      img {
        vertical-align: middle;
        margin-right: 0.8rem;
      }
    }
  }

  //@media screen and (max-width: 1199px) {
  //  overflow-y: auto;
  //}

  /* @media screen and (max-width: 1199px) {
    height: 100%;
    position: fixed;
    width: 32rem;
    max-width: 90%;
    padding-bottom: 0;
    top: ${(p) => (p.$main ? '5.4rem' : '7rem')};
    > div {
      > button {
        font-size: 1.6rem;

        a {
          padding: 1.5rem 1.7rem;
          font-size: 1.6rem;
        }
      }
    }
  }
  @media screen and (max-width: 764px) {
    top: 5.4rem;
  } */
`;
